import React from 'react';
import { Form, Table, Cascader, Row, Col, Tabs } from 'antd';
import withSpin from 'components/withSpin';
import AssignRole from './AssignRole';
import RoleManager from './RoleManager';
import axios from 'axios';

import apiPath from 'apiPath';

const TabPane = Tabs.TabPane;


class AdminRole extends React.Component {

    state = {
        Roles: [],
        isAllowed: false
    }

    getRole = () => {
        axios.get(apiPath + '/adminRole/getRole').then(result => {
            this.setState({
                Roles: result.data
            });
        })
    }

    //Get admin email
    getAdminEmail = () => {
        axios.get(apiPath + '/getAdmin', { withCredentials: true }).then(result => {
            if (result.data === 'refactored@isevoyages.org' || result.data === 'tparker@isevoyages.org' || result.data === 'sadvani@isevoyages.org' || result.data === 'schapman@isevoyages.org') {
                this.setState({ isAllowed: true })
            }
        })
    }

    componentDidMount() {
        this.getRole();
        this.getAdminEmail();
    }

    render() {
        let routeProps = this.props;
        return (
            <div>
                {this.state.isAllowed === true &&
                    <Tabs defaultActiveKey="1" type="card" style={{ margin: '20pt' }}>
                        <TabPane tab="Assign A Role" key="1" style={{ backgroundColor: 'white', marginTop: '-16px', paddingBottom: '60pt' }}>
                            <AssignRole Roles={this.state.Roles} getRole={this.props.getRole} />
                        </TabPane>
                        <TabPane tab="Edit/Add A Role" key="2" style={{ backgroundColor: 'white', marginTop: '-16px', paddingBottom: '60pt' }}>
                            <RoleManager Roles={this.state.Roles} getRole={this.getRole} />
                        </TabPane>
                    </Tabs>
                }
            </div>
        );
    }

}

export default withSpin(AdminRole);



// WEBPACK FOOTER //
// ./portal-components/Portal/AdminRole/index.jsx